import vuex from '@/store'
import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
  RouteRecordRaw,
  useRoute,
} from 'vue-router'
const baseConfig = require('../../config/config.js')
import { startQiankun } from '@/qiankun'
// 手动控制应用加载
import { loadMicroApp } from 'qiankun'
import MICRO_CONF from './../qiankun/config'
import service from '@/services'
import { computed } from 'vue'
import { $t as lang } from '@/Tool'
const { publicPath } = baseConfig
let current: any
// 缓存应用实例
const microList = new Map([])

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/pages/Login/index.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/Login/index.vue'),
  },
  {
    path: '/company-contract',
    name: 'companyContract',
    component: () => import('@/pages/CompanyContract/index.vue'),
  },
  // {
  //   path: '/school/login',
  //   name: 'school',
  //   component: () => import('@/pages/Login/index.vue'),
  // },
  {
    path: '/huaweiyun/login',
    name: 'huaweiLogin',
    component: () => import('@/pages/Login/index.vue'),
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('@/pages/Agreement/Agreement.vue'),
  },
  {
    path: '/agreementEn',
    name: 'agreementEn',
    component: () => import('@/pages/Agreement/Agreement_en.vue'),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/pages/Agreement/Privacy.vue'),
  },
  {
    path: '/privacyEn',
    name: 'privacyEn',
    component: () => import('@/pages/Agreement/Privacy_en.vue'),
  },
  {
    path: '/chat-image-agreement',
    name: 'chatImageAgreement',
    component: () => import('@/pages/Agreement/ChatImageAgreement.vue'),
  },
  {
    path: '/video-appearance',
    name: 'videoAppearance',
    component: () => import('@/pages/Agreement/VideoAppearance.vue')
  },
  {
    path: '/guide',
    name: 'guide',
    component: () => import('@/pages/guide/guide.vue'),
  },
  {
    path: '/:catchAll(.*)*',
    name: 'manage',
    component: () => import('@/pages/Home/Manage.vue'), // home里面存放所有全局布局的组件
    children: [
      {
        path: 'homePage',
        name: 'homePage',
        component: () => import('@/pages/HomePage/HomePage.vue'),
      },
      {
        path: 'accountSetting',
        name: 'accountSetting',
        component: () => import('@/pages/accountSetting/index.vue'),
      },
      {
        path: 'messageCenter',
        name: 'messageCenter',
        component: () => import('@/pages/MessageCenter/index.vue'),
      },
    ],
  },
  {
    path: '/kol/join',
    name: 'KolJoin',
    component: () => import('@/pages/Kol/Join/index.vue'),
  },
  {
    path: '/wechatLogin',
    name: 'wechatLogin',
    component: () => import('@/pages/ThirdPartyLogin/WechatLogin.vue'),
  }
]

const router = createRouter({
  history: createWebHashHistory(publicPath),
  routes,
})
const isHuawei = localStorage.getItem('isHuaweiyun')
// const fullPath = useRoute().fullPath;
// 退出登录时卸载微应用
function unmountMicroApp() {
  microList.forEach((item: any) => item.unmount())
}

// async function queryUserInfo() {
//   try {
//     const res: any = await service.Scrm_sys_api.srcmLogin.getUserInfo({
//       error: false,
//       success: false,
//       data: {},
//     })
//     return res
//   } catch (e) {
//     return e
//   }
// }
// 判断是否有首页权限
// const initHomePage = () => {
//   let userInfo: any = {}
//   if (sessionStorage.getItem('__user')) {
//     userInfo = JSON.parse(sessionStorage.getItem('__user') + '')
//   }
//   const menuCodes = userInfo?.user.info?.menuCodes || []
//   const hasHomePage = computed(() => menuCodes.indexOf('home') >= 0)
//   if (hasHomePage.value) {
//     vuex.commit('set_data', {
//       tabsArr: [
//         {
//           key: 'home',
//           name: '模特市场&home',
//           url: '/vshow/modelMarket',
//           parentKey: '',
//           child: [],
//         },
//       ],
//       activeTabName: '模特市场&home',
//     })
//   }
// }

router.beforeEach((to, form, next) => {
  // document.title = (to.meta.title ? to.meta.title : lang('mainMenu.page.title')) as string

  //官网跳转小视频 带token免登录
  // if (to.query.token) {
  //   const token = to.query.token as string
  //   vuex.commit('set_data', {
  //     user: { token: token },
  //   })
  //   queryUserInfo().then((res) => {
  //     const { data, success } = res
  //     if (data && success) {
  //       vuex.commit('set_data', {
  //         user: {
  //           token: token,
  //           info: data,
  //           orgid: data.corpId,
  //         },
  //         currentMicroDom: to.path,
  //       })
  //       initHomePage()
  //       console.log(to, '000000000')
  //       next()
  //     }
  //   })
  // }

  vuex.commit('set_data', {
    currentMicroDom: to.path,
  })
  
  // 检查是否是登录相关路由（包括根路径和登录页）
  const isLoginRoute = to.name === 'index' || to.name === 'login' || to.name === 'huaweiLogin' || 
                       to.path === '/' || to.path === '/login' || to.path === '/huaweiyun/login'
  
  if (vuex.state.user.info) {
    // 已登录用户访问登录页，可以允许访问（因为可能需要重新登录或其他操作）
    next()
  } else {
    // 未登录用户
    current = null
    unmountMicroApp()
    microList.clear()
    const WhiteList = [
      'login',
      'index', // 添加 index 到白名单
      'chatImageAgreement',
      'agreement',
      'agreementEn',
      'privacy',
      'privacyEn',
      'huaweiLogin',
      'school',
      'modelDetail',
      'KolJoin',
      'wechatLogin',
      'companyContract',
    ]
    if (WhiteList.includes(to.name as string) || to.path.includes('modelDetail') || isLoginRoute) {
      next()
    } else {
      next({
        name: 'login',
      })
    }
  }
})
router.afterEach((to, from) => {
  const conf = MICRO_CONF.find((item) => {
    // return to.path.indexOf(item.activeRule.replace(/.+\/#\//,"")) !== -1
    return to.path.indexOf(item.activeRule.split('#')[1]) !== -1
  })
  // 应用跳转
  if (conf) {
    // 未切换子应用
    if (current && current.activeRule === conf.activeRule) {
      return
    }
    const cacheMicro = microList.get(conf.activeRule)
    // 已缓存应用
    if (cacheMicro) {
      // const micro = loadMicroApp({...conf})
      // microList.set(conf.activeRule, micro)
      current = conf
      return
    }
    const micro = loadMicroApp({ ...conf })

    microList.set(conf.activeRule, micro)
    current = conf
    return
  }
})

export default router
